import { useTenantContext } from '../../../context/TenantProvider';
import Spinner from '../../../components/Spinner/Spinner';

export interface TenantGuardProps {
  children: React.ReactNode;
}
const TenantGuard = ({ children }: TenantGuardProps) => {
  const { isLoading, status, tenant } = useTenantContext();

  if (isLoading)
    return (
      <div className="w-full h-full flex items-center justify-center">
        <Spinner size="large" />
      </div>
    );

  // A failed refresh keeps the tenant it already read and still reports `error`
  if (status === 'error' && !tenant) {
    // TODO Add actual error page to indicate tenant error
    return <p>Oops... Something went wrong</p>;
  }
  return children;
};

export default TenantGuard;
